import { Dispatch } from 'react';
import { Logger } from 'src/utils';
import AppService from 'src/services/AppService';
import { configUpdate, regionUpdate } from './dispatchActions';

export const loadAppConfig = () => async (dispatch: Dispatch<any>) => {
    AppService.getConfig()
        .then((resp) => {
            if (resp && resp.data) {
                dispatch(configUpdate(resp.data));
            }
        })
        .catch((err) => {
            if (err) {
                Logger.error(err.err, 'loadAppConfig fail|', err);
            }
        });
};

export const loadAppRegion = () => async (dispatch: Dispatch<any>) => {
    AppService.getRegion()
        .then((resp) => {
            if (resp && resp.data) {
                dispatch(regionUpdate(resp.data));
            }
        })
        .catch((err) => {
            if (err) {
                Logger.error(err.err, 'loadAppRegion Fail|', err);
            }
        });
};

export const checkInstallZalo = () => {
    AppService.checkApp({ installedZalo: true })
        .then((resp) => {
            if (resp && resp.data) {
                const { installedZalo = false } = resp.data;
                (window as any)._BM.installZalo = installedZalo;
            }
        })
        .catch((err) => {
            if (err) {
                Logger.error(err.err, 'checkInstallZalo Fail|', err);
            }
        });
};
